import cfg from '../gridConstans';
import { TStep } from '../type';

const { COUNT } = cfg.LEGEND.LABELS;

export default function useSteps(maxWeeks: number, maxCount: number) {
  const calcStep = (value: number, limit: number) => {
    const div = Math.floor(value / limit);

    if (div > 1000) return Math.ceil(div / 1000) * 1000;
    if (div > 100) return Math.ceil(div / 100) * 100;
    if (div > 10) return Math.ceil(div / 10) * 10;
    if (div >= 6) return 10;
    if (div >= 4) return 5;
    if (div >= 2) return 3;
    return 1;
  };

  const steps: TStep = {
    horisontal: calcStep(maxWeeks, COUNT.HORISONTAL),
    vertical: calcStep(maxCount, COUNT.VERTICAL),
  };

  return steps;
}
